import { render, staticRenderFns } from "./RedefinirSenha.vue?vue&type=template&id=22d998ef&scoped=true&"
import script from "./RedefinirSenha.vue?vue&type=script&lang=js&"
export * from "./RedefinirSenha.vue?vue&type=script&lang=js&"
import style0 from "./redefinir_senha.scss?vue&type=style&index=0&id=22d998ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d998ef",
  null
  
)

export default component.exports